import { pharmacyLoginActions } from '../../../../actions/user/pharmacy/Account/login';
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const initialState = {
  user: null,
  loading: false,
  error: null,
  successMessage: null,
  isVerified: false,
  isAuthenticated: false,
  isModalOpen: false
};

const pharmacyLoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case pharmacyLoginActions.LOGIN_PHARMACY.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        successMessage: null
      };
    case pharmacyLoginActions.LOGIN_PHARMACY.SUCCESS:
      console.log('Login Success Payload:', action.payload);

      const accessToken = action.payload.tokens.access;
      cookies.set('auth_token', accessToken, { path: '/', secure: true, sameSite: 'Strict' });

      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
        successMessage: action.payload.message,
        isAuthenticated: !!accessToken
        // isVerified: action.payload.is_email_verified,
        // isModalOpen: !action.payload.is_email_verified,
      };
    case pharmacyLoginActions.LOGIN_PHARMACY.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error?.error,
        isVerified: false,
        isModalOpen: action.error?.error === 'Please verify your email first'
      };
    case pharmacyLoginActions.LOGIN_PHARMACY.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default pharmacyLoginReducer;
